module.exports = __webpack_public_path__ + "static/media/about-vision-2025.f2a20d04.png";